import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'shared-ui-modal-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.css'],
    standalone: false
})
export class ConfirmModalComponent {
  @Input() title!: string;

  @Input() body!: string;

  @Output() confirmOutput = new EventEmitter<void>();
}
